export const ppm = ['Moisture', 'HF', 'CI', 'SO4', 'Na', 'K', 'Ca', 'Fe', 'Pb'];
export const APHA = ['Color'];
export const g_cm3 = ['Density'];
